export enum Sort {
  popularity = 'rank',
  publishedAt = 'published_at',
  price = 'price',
  rating = 'rating',
  discount = 'discount',
}
